import React from 'react'
import { DeliveryService } from 'react-at-rest'
import BaseStore from '../../stores/BaseStore'

export class ZoneText extends DeliveryService {
  constructor (props) {
    super(props)
    this.zoneStore = new BaseStore('zones')
  }

  bindResources (props) {
    this.retrieveResource(this.zoneStore, {
      id: props.addressState.substr(1),
      query: {
        $disableSoftDelete: true
      }
    })
  }

  render () {
    if (!this.state.loaded) return null

    return (
      <span>{'Zone: ' + this.state.zone.name}</span>
    )
  }
}
